import React, { useState, useEffect } from 'react'
import { Col, FlexboxGrid, Panel, Row } from 'rsuite'
import moment from 'moment'
import RenderInputWidget from '../dynamicForm/RenderInputWidget'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { cloneDeep } from 'lodash-es'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import InputForm from '../../../components/forms/input/InputForm'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import InputRadioForm from '../../../components/forms/input/InputRadioForm'
import InputDateForm from '../../../components/forms/input/InputDateForm'
import { setAlertMessage } from '../../../utils/messageUtil'
import { REQUEST_DATE_FORMAT } from '../../../constants/date'

export default function ActivitieTimeWidget({
  schema,
  header,
  items,
  newItems,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  newActivitieTimeName = 'newActivitieTimeName',
  button,
  ...props
}) {
  const [inputList, setInputList] = useState([])
  const [newInputList, setNewInputList] = useState([])
  const [newInputIdex, setNewInputIdex] = useState(0)
  const [activityTimeType, setActivityTimeType] = useState(1)
  const [refreshValue, setRefreshValue] = useState(false)

  useEffect(() => {
    items?.forEach((e) => {
      e.options = schema?.activityTimeData?.options || []
    })
    setInputList(items)
  }, [items])

  useEffect(() => {
    const normalizedItems =
      newItems?.map((item) => ({
        ...item,
        startDate: item?.startDate ? moment(item.startDate).format(REQUEST_DATE_FORMAT) : item?.startDate,
        endDate: item?.endDate ? moment(item.endDate).format(REQUEST_DATE_FORMAT) : item?.endDate,
      })) || []

    setNewInputList(normalizedItems)
    setValue(newActivitieTimeName, normalizedItems)

    setActivityTimeType(normalizedItems?.length > 0 ? normalizedItems[0].type : '1')
  }, [newItems])

  const handleAddNew = () => {
    let inputs = cloneDeep(newInputList || [])
    let type = '1'
    setActivityTimeType(type)

    let data = {
      id: `NEW_0`,
      //label: '',
      type: type,
      value: '',
      start: '',
      end: '',
    }

    inputs.push(data)
    setNewInputList(inputs)
    setNewInputIdex(1)

    setValue(newActivitieTimeName, inputs)
  }

  const handleAdd = () => {
    let inputs = cloneDeep(newInputList || [])

    let data = {
      id: `NEW_${newInputIdex}`,
      //label: '',
      type: inputs[0]?.type,
      value: '',
      start: '',
      end: '',
    }

    inputs.push(data)
    setNewInputList(inputs)
    setNewInputIdex(newInputIdex + 1)

    setValue(newActivitieTimeName, inputs)
  }

  const handleRemove = (index) => {
    // let newId = 'NEW_' + datas.length
    let inputs = cloneDeep(newInputList || [])

    inputs.splice(index, 1)

    setNewInputList(inputs)

    setValue(newActivitieTimeName, inputs)
  }

  return (
    <Panel
      style={props.style || { marginTop: 20 }}
      header={header || 'ช่วงเวลาที่จัดกิจกรรม'}
      collapsible //={props.collapsible}
      defaultExpanded //={props.defaultExpanded}
      bordered //={props.bordered}
    >
      <div style={{ marginTop: -10 }}>
        {inputList?.length > 0 && (
          <>
            <RenderInputWidget
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              inputs={inputList}
            />
          </>
        )}
        <>
          {newInputList?.length > 0 && (
            <>
              <InputRadioForm
                name={`${schema.type.name}`}
                schema={schema.type}
                value={activityTimeType}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                inline
                onChange={(value) => {
                  setNewInputList([
                    {
                      id: `NEW_${0}`,
                      label: '',
                      type: value,
                      value: '',
                      start: '',
                      end: '',
                    },
                  ])

                  setNewInputIdex(1)

                  setActivityTimeType(value)
                }}
              />
            </>
          )}
          {newInputList?.map((e, index) => {
            return (
              <FlexboxGrid align="bottom" justify="space-around">
                {activityTimeType == '1' && (
                  <>
                    <FlexboxGrid.Item
                      componentClass={Col}
                      colspan={24}
                      xs={24}
                      sm={24}
                      md={18}
                      lg={20}
                    >
                      <InputSelectForm
                        name={`${e.id}:${schema.activityTimeData.name}`}
                        schema={schema.activityTimeData}
                        value={e.value}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        refreshValue={refreshValue}
                        onChange={(value) => {
                          let inputs = cloneDeep(newInputList)

                          if (newInputList.find((e) => e.value == value)) {
                            setAlertMessage('error', 'เลือกเดือนซ้ำ กรุณาเลือกใหม่')

                            value = null
                            setRefreshValue(true)
                            setTimeout(() => {
                              setRefreshValue(false)
                            }, 50)
                          }

                          inputs[index].value = value
                          setNewInputList(inputs)
                          setValue(newActivitieTimeName, inputs)
                        }}
                      />
                    </FlexboxGrid.Item>
                  </>
                )}
                {activityTimeType == '2' && (
                  <>
                    <FlexboxGrid.Item
                      componentClass={Col}
                      colspan={24}
                      xs={24}
                      sm={24}
                      md={2}
                      lg={2}
                    >
                      <div style={{ marginBottom: 20 }}>ช่วงที่ {index + 1}</div>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item
                      componentClass={Col}
                      colspan={24}
                      xs={24}
                      sm={24}
                      md={7}
                      lg={8}
                    >
                      <InputDateForm
                        name={`${e.id}:${schema.startDate.name}`}
                        schema={schema.startDate}
                        value={e.startDate}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        endDate={e.endDate}
                        onChange={(value) => {
                          let inputs = cloneDeep(newInputList)
                          inputs[index].startDate = value
                            ? moment(value).format(REQUEST_DATE_FORMAT)
                            : null
                          setNewInputList(inputs)
                          setValue(newActivitieTimeName, inputs)
                        }}
                      />
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item
                      componentClass={Col}
                      colspan={24}
                      xs={24}
                      sm={24}
                      md={7}
                      lg={8}
                    >
                      <InputDateForm
                        name={`${e.id}:${schema.endDate.name}`}
                        schema={schema.endDate}
                        value={e.endDate}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        startDate={e.startDate}
                        //endDate={endDate}
                        onChange={(value) => {
                          let inputs = cloneDeep(newInputList)
                          inputs[index].endDate = value
                            ? moment(value).format(REQUEST_DATE_FORMAT)
                            : null
                          setNewInputList(inputs)
                          setValue(newActivitieTimeName, inputs)
                        }}
                      />
                    </FlexboxGrid.Item>
                  </>
                )}

                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={4}>
                  <CancelButton
                    icon="trash-o"
                    children="ลบ"
                    style={{ marginBottom: 5 }}
                    onClick={() => {
                      handleRemove(index)
                    }}
                  />
                  {index == newInputList.length - 1 && (
                    <SaveButton
                      style={{ marginBottom: 5, marginLeft: 10 }}
                      icon="plus"
                      children={`เพิ่ม`}
                      onClick={handleAdd}
                    />
                  )}
                </FlexboxGrid.Item>
              </FlexboxGrid>
            )
          })}

          {(!newInputList || newInputList?.length == 0) && (
            <SaveButton
              style={{ marginTop: 20 }}
              icon="plus"
              children={`เพิ่ม${header || ''}`}
              onClick={handleAddNew}
            />
          )}
        </>
        <Controller
          key={newActivitieTimeName}
          name={newActivitieTimeName}
          control={control}
          defaultValue={newInputList}
          values={newInputList}
        />
      </div>

      {button ? <>{button}</> : ''}
    </Panel>
  )
}
